import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { ICRSchedule } from '@ruby/modules/customized-reporting/models/report.interface';

@Component({
  selector: 'ng-report-details-schedule',
  templateUrl: './report-details-schedule.component.html',
  styleUrls: ['./report-details-schedule.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ReportDetailsScheduleComponent {
  @Input() schedule?: ICRSchedule;

  constructor() { }
}
